<template>
	<div
		class="space-y-4 sm:flex sm:items-center sm:space-y-0 sm:space-x-4 text-gray-100"
	>
		<div
			class="flex items-center"
			v-for="(option, idx) in localOptions"
			:key="idx + '-' + option.checked"
		>
			<input
				:id="'location__hub' + option.value"
				v-model="option.checked"
				type="checkbox"
				checked="checked"
				@click="toggle(idx)"
				class="h-5 w-5 bg-gray-600 border-gray-600 rounded text-orange focus:ring-orange"
			/>
			<label
				:for="'location__hub' + option.value"
				class="ml-3 block font-medium whitespace-nowrap"
			>
				<span>{{ __(option.label) }}</span>
				<!--<span class="text-gray-400">{{ option.name_short }}</span>-->
			</label>
		</div>
	</div>
</template>

<script>
import UiButtonSelect from "./ButtonSelect.vue";
export default {
	mixins: [UiButtonSelect],
};
</script>
